
import Moment from "moment";
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Department } from "../../../../../../../domain/department";
import { IClaioImageSource } from "../../../../../../../domain/claio";
import { ModelEditableMixin } from "../../../../../../system/mixins";

@Component
export default class ClaioContentsFilterMixin extends Mixins(ModelEditableMixin) {
  @Prop()
  source: IClaioImageSource[];

  @Prop()
  departments: Department[];

  data(): any {
    return {
      selectedSource: null as IClaioImageSource,
    };
  }
  selectedSource: IClaioImageSource;

  get shouldOrderByAscending(): boolean {
    return this.$configuration.behavior.document.editor.contents.claio.shouldOrderByAscending;
  }

  getImageSourceOptionName(image: IClaioImageSource): string {
    return Moment(image.imageDate).format("YYYY/MM/DD") + " " + this.getDepartmentName(image.departmentId);
  }

  getDepartmentName(departmentId: string): string {
    const department = Enumerable.from(this.departments).firstOrDefault(d => d.id === departmentId);
    return department ? department.name : "";
  }
}
